module.exports = __webpack_public_path__ + "img/lea-1.5db7833e.png";